import React from 'react';
import { Box, TextField, Button, Menu, MenuItem, InputAdornment } from '@mui/material';
import { Search, FilterList, Sort } from '@mui/icons-material';
import { SearchControlsProps } from './types';

/**
 * SearchControls - Search, filter, and sort controls for the dashboard
 */
const SearchControls: React.FC<SearchControlsProps> = ({
  searchQuery,
  setSearchQuery,
  filterMenuAnchor,
  setFilterMenuAnchor,
  sortMenuAnchor,
  setSortMenuAnchor,
  setStatusFilter,
  setSortOption
}) => {
  return (
    <Box sx={{ mb: 3, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, alignItems: { xs: 'stretch', md: 'center' } }}>
      <TextField
        fullWidth
        placeholder="Search by application #, title, applicant, or address"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        sx={{ flexGrow: 1 }}
      />

      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          startIcon={<FilterList />}
          onClick={(e) => setFilterMenuAnchor(e.currentTarget)}
        >
          Filter
        </Button>

        <Button
          variant="outlined"
          startIcon={<Sort />}
          onClick={(e) => setSortMenuAnchor(e.currentTarget)}
        >
          Sort
        </Button>
      </Box>

      {/* Filter Menu */}
      <Menu
        anchorEl={filterMenuAnchor}
        open={Boolean(filterMenuAnchor)}
        onClose={() => setFilterMenuAnchor(null)}
      >
        <MenuItem onClick={() => { setStatusFilter('all'); setFilterMenuAnchor(null); }}>
          All Statuses
        </MenuItem>
        <MenuItem onClick={() => { setStatusFilter('Scheduled'); setFilterMenuAnchor(null); }}>
          Scheduled
        </MenuItem>
        <MenuItem onClick={() => { setStatusFilter('Rescheduled'); setFilterMenuAnchor(null); }}>
          Rescheduled
        </MenuItem>
        <MenuItem onClick={() => { setStatusFilter('In Progress'); setFilterMenuAnchor(null); }}>
          In Progress
        </MenuItem>
        <MenuItem onClick={() => { setStatusFilter('Pass'); setFilterMenuAnchor(null); }}>
          Completed
        </MenuItem>
        <MenuItem onClick={() => { setStatusFilter('issue'); setFilterMenuAnchor(null); }}>
          Has Issues
        </MenuItem>
      </Menu>

      {/* Sort Menu */}
      <Menu
        anchorEl={sortMenuAnchor}
        open={Boolean(sortMenuAnchor)}
        onClose={() => setSortMenuAnchor(null)}
      >
        <MenuItem onClick={() => { setSortOption('date-asc'); setSortMenuAnchor(null); }}>
          Date (Earliest First)
        </MenuItem>
        <MenuItem onClick={() => { setSortOption('date-desc'); setSortMenuAnchor(null); }}>
          Date (Latest First)
        </MenuItem>
        <MenuItem onClick={() => { setSortOption('priority-high'); setSortMenuAnchor(null); }}>
          Priority (Highest First)
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default SearchControls;